// extracted by mini-css-extract-plugin
module.exports = {"root":"index-m-root-2FbDU"};